import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(ElementUI)

const bootstrap = store.dispatch('fetchUserInfo').finally(() => {
  // 已登录时恢复全局 WebSocket，连接成功后自动 login(user_id)
  if (store.state.token && store.state.user && store.state.user.id) {
    store.dispatch('websocket/connectAppWebSocket').catch(() => {})
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

void bootstrap
